import SvgIcon from '../SvgIcon/SvgIcon';

function InstagramIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <path d="M15.38,20.45H9.17a5.09,5.09,0,0,1-5-5.17V9.62a5.09,5.09,0,0,1,5-5.17h6.21a5.09,5.09,0,0,1,5,5.17v5.66A5.09,5.09,0,0,1,15.38,20.45ZM9.13,5.52A4,4,0,0,0,5.19,9.58v5.73a4,4,0,0,0,3.94,4.07h6.29a4,4,0,0,0,3.94-4.07V9.58a4,4,0,0,0-3.94-4.06Z" />
      <path d="M12.28,8.45a4,4,0,1,0,4,4A4,4,0,0,0,12.28,8.45Zm0,7a3,3,0,1,1,3-3A3,3,0,0,1,12.28,15.45Z" />
      <path d="M16.73,8.05a.81.81,0,1,1-.81-.8.8.8,0,0,1,.81.8" />
    </SvgIcon>
  );
}

export default InstagramIcon;
